'use strict';

var processInclude = require('./util');

$(function () {
    processInclude(require('./login/login'));
    processInclude(require('./components/passwordValidation'));
    processInclude(require('./components/passwordToggle'));
    processInclude(require('./components/emailValidation'));
    processInclude(require('./components/nameValidation'));
    processInclude(require('./components/disableSubmitButton'));
});
